export default {
  '3D展示': '3D展示',
  '3D展览': '3D展览',
}
